  window.addEventListener('load', function () {
    document.querySelectorAll('[id="AddToCart"]').forEach(function(check){
      check.onmousedown = function(){
        gtag('event', 'conversion', {'send_to': 'AW-810397593/sJKDCOC-j9oDEJnftoID'});
      }
    })
  });

  function getMessage(element, data){
    var greetdata = data.replace(/\s/g," ");
     $("#card-message").html(data);
  }
   

  $('body').on('click', '.product-variants-list .variant-selected', function(){
    $(this).parent(".product-variants-list").addClass('open');
  });

  $(".product-variants-list").mouseleave(function() {
      $(this).removeClass('open');
  });
  
  function getVariant(element, ID, pid, image, price){
    $(".product-variant-value").removeClass("current-variant");
    element.addClass("current-variant");
    $("#getproduct-variant-"+pid).val(ID);
    var new_val = element.html();
    $("#product-"+pid).html(new_val);
    $(".product-variants-list").removeClass('open');
    $('#image-product-'+pid).attr( 'src', image);
   // console.log(price/100);
    $(".product-id-"+pid+" #ProductPrice .money .money").html("$"+price/100)

  }


  //Modal Actions
//center modal based on window size
function centerModal(){
   var modal = $('.modal.open');
   var mWidth = modal.outerWidth()
   var mHeight = modal.outerHeight();
   var width = $(window).width();
   var height = $(window).height();
   if((width % 1) != 0){
      width = Math.round(width)
   }
   if((height % 1) != 0){
      height = Math.round(height)
   }
   var topPos = (height / 2) - (mHeight / 2);
   var leftPos = (width / 2) - (mWidth / 2); 
   modal.css({top: topPos, left:leftPos})
}
//open modal and overlay
function openModal(){
   $('.modal').removeClass('hidden').addClass('open');
   $('.modal--overlay').removeClass('hidden').addClass('open');
   $('body').css('overflow', 'hidden');
   centerModal();
}

//close modal and overlay
function closeModal(overlay){
   $(overlay).addClass('hidden').removeClass('open');
   $('.modal.open').addClass('hidden').removeClass('open');
  $('.modal--overlay').removeClass('open').addClass('hidden');
   $('body').css('overflow', 'auto');
}
  
  
function customAddToCart(element, pid){
 var productId = $("#getproduct-variant-"+pid).val();
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            type: 'post',
            data: {
              quantity: 1,
              id: productId
            },
            success:addToCartOk,
            error: erromessage
          });
    }
function addToCartOk(product){
   $('.modal').html(product.title + ' was added to the cart!');
   openModal();
  setTimeout(function() {closeModal()}, 4000);
}
function erromessage(product){
  //$('.modal').html(product[2] + ' error');
  // openModal();
  console.log(product);
}  
$('.modal--overlay').on('click', function(){
   var overlay = $('.modal--overlay')
   closeModal(overlay);
});
  $('.new-cross-sells').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 4,
    responsive: [
      {
            breakpoint: 1100,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }
      ]
});